import { axios } from '../configs';
import type {
  TSendHistoryResponse,
  TSendHistoryDetail,
  TSendHistoryClickedUsers,
} from 'types/sendHistory';
import type { TSummarySourceType } from 'types/summary';

export type SendHistoryQuery = {
  from: string;
  to: string;
  sourceType?: TSummarySourceType;
  currentPage?: number;
  pageSize?: number;
};
export async function getSendHistory(
  params: SendHistoryQuery,
): Promise<TSendHistoryResponse> {
  return (
    await axios.get<TSendHistoryResponse>('messages/send-history', { params })
  ).data;
}
export async function getSendHistoryDetail(
  id: string,
): Promise<TSendHistoryDetail> {
  return (await axios.get<TSendHistoryDetail>(`messages/send-history/${id}`))
    .data;
}
export async function getSendHistoryClickedUsers(
  id: string,
  params: { currentPage: number; pageSize: number },
): Promise<TSendHistoryClickedUsers> {
  return (
    await axios.get<TSendHistoryClickedUsers>(
      `messages/send-history/${id}/clicked-users`,
      { params },
    )
  ).data;
}
